<template>

  <div class="inner-banner">
    <div class="copy" v-bind:class="subText ? 'with-sub' : ''">
      <h1 class="serif">{{title}}</h1>
      <p v-if="subText">
        {{subText}}
      </p>
    </div>
    <div class="overlay"></div>
    <div class="bg">
      <picture v-bind:title="title">
        <!--[if IE 9]><video style="display: none;"><![endif]-->
        <source v-bind:srcset="imageUrl + '_500.jpg'" media="(max-width: 500px)">
        <source v-bind:srcset="imageUrl + '_800.jpg'" media="(min-width: 501px) and (max-width: 800px)">
        <source v-bind:srcset="imageUrl + '_1200.jpg'" media="(min-width: 801px) and (max-width: 1200px)">
        <source v-bind:srcset="imageUrl + '_1600.jpg'" media="(min-width: 1201px) and (max-width: 1600px)">
        <source v-bind:srcset="imageUrl + '_2000.jpg'" media="(min-width: 1601px)">
        <!--[if IE 9]></video><![endif]-->
        <img v-bind:src="imageUrl + '_1600.jpg'" alt="">
      </picture>
    </div>
  </div>
</template>

<script>

export default {
    props: ['title', 'imageUrl', 'subText'],

    data() {
      return {
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .inner-banner { position: relative; }
  .inner-banner .copy { color: #404040;width:100%;padding:0px 20px;text-align: center;position:absolute; top:50%;left:0px; z-index: 2; color:#FFFFFF;margin-top:-20px;}
  .inner-banner .copy.with-sub {margin-top:-50px;}
  .inner-banner .copy h1 { font-size: 40px; color: #FFFFFF; margin:0px;padding:0px;}
  .inner-banner .copy p { font-size: 20px;margin-top:20px;}

  .inner-banner .overlay { background: rgba(66,133,249,0.5); position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; z-index: 1; }
  .inner-banner .bg img { width: 100%; }

  @media only screen and (max-width: 700px) {
    .inner-banner {  }
    .inner-banner .copy { margin-top: -15px; }
    .inner-banner .copy.with-sub { margin-top: -30px; }
    .inner-banner .copy h1 { font-size: 30px; }
    .inner-banner .copy p { font-size:15px;}
  }

  @media only screen and (max-width: 500px) {
    .inner-banner { }
      .inner-banner .copy { margin-top: -15px; }
        .inner-banner .copy.with-sub { margin-top: -30px; }
        .inner-banner .copy h1 { font-size: 20px; }
        .inner-banner .copy p { font-size: 14px; }
  }

  @media only screen and (min-width:501px) and (max-width: 800px) {
  }

  @media only screen and (min-width:801px) and (max-width: 1200px) {
  }

  @media only screen and (min-width:1201px) and (max-width: 1600px) {
  }

  @media only screen and (min-width:1601px) {
  }

</style>



// WEBPACK FOOTER //
// InnerBanner.vue?73d360d3